export enum DefectTabs {
    summary,
    defects,
    gradingArea,
    recurringDefects,
    insights   
}
